/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const dialogModalStyle = {
  dialogModal: {
    margin: "auto",
  },
  xs: {
    minWidth: "350px",
  },
  md: {
    minWidth: "48rem",
  },
  lg: {
    minWidth: "64rem",
  },
  dialogModalTitle: {
    padding: "1rem 2rem",
    borderBottom: "1px solid #d4d4d4",
  },
  closeIcon: {
    position: "absolute",
    right: "10px",
    top: "10px",
    height: "28px",
    width: "28px",
    color: "text.light",
    cursor: "pointer",
  },
  dialogModalContent: (theme: Theme) => ({
    padding: "0 2rem",
    [theme.breakpoints.up("sm")]: {
      padding: "0 5rem",
    },
  }),
  dialogModalActions: {
    borderTop: "1px solid #d4d4d4",
    padding: "1.5rem",
  },
};

export default dialogModalStyle;
